module.exports = __webpack_public_path__ + "Flag-498.c2c1aca88fa318ca68349b11c44926ae.svg";